

















import { FeatureFlags, UserPermission } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import EmployerLogoUpload from "./EmployerLogoUpload.vue";
import EmployerSupport from "./EmployerSupport.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";



@Component({
  components: {
    EmployerLogoUpload,
    EmployerSupport
  }
})
export default class EmployerCustomization extends Vue {

  featureFlagStore = useFeatureFlagStore();
  rolePermissions = useRolePermissionsStore();
  @Prop() employerId: any;

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
      : true;
  }
}
